<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage kyoboView"
  >
    <header-area />

    <div class="worksView topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">Integrate financial<br />services center around mobile</div>
            <div class="workSlogan mobile">
              Integrate financial<br />services center<br />around mobile
            </div>
            <div class="workTopDay">
              <p>교보생명 모바일 통합 구축</p>
              <ul>
                <li>PC / Mobile web / App</li>
                <li>2022.09.19</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://www.kyobo.com" target="_blank" class="siteAddr"
                >https://www.kyobo.com</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/kyobo"
                    title="모바일을 중심으로 하나된 디지털 채널"
                    hashtags="플립커뮤니케이션즈,교보생명"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/kyobo"
                    title="모바일을 중심으로 하나된 디지털 채널"
                    hashtags="플립커뮤니케이션즈,교보생명"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt">
            <marquee-text :duration="15"
              >&nbsp;Integrate financial services center around mobile&nbsp;</marquee-text
            >
          </span>
          <img class="web" src="@/assets/images/works_view/kyobo/visual.jpg" alt="" />
          <img class="mobile" src="@/assets/images/works_view/kyobo/visual_m.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          교보생명의 대표 디지털 채널인 홈페이지는 2012년 리뉴얼 이후 부분적인 서비스 개편을 통해
          운영되어 왔습니다. 또한, 기존에는 PC와 모바일 웹, 앱마다 제공하는 서비스 범위가 달라
          고객이 업무를 처리하는 과정에서 혼선이 자주 일어났습니다. 이에 교보생명은 일관된 고객
          경험과 확장된 서비스를 제공하고자 자사 디지털 채널을 통합 리뉴얼하는 채널 차세대 성격의
          프로젝트를 진행했습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <div class="kyoboCon topGoal">
          <div class="smallTit">GOAL</div>
          <div
            class="txtWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="tit">모바일을 중심으로 <b>서비스 통합</b></div>
            <p>
              제각기 다른 서비스를 제공하는 채널들을 모바일을 중심으로 <br class="web" />하나의
              서비스로 통합하는 것이 가장 큰 목표였습니다. <br class="web" />특히, 모바일 앱은
              마이데이터 서비스와 다양한 제휴 서비스를 품은 <br class="web" />플랫폼 서비스로 확장할
              수 있도록 그 기반을 마련하고자 했습니다.
            </p>
          </div>
          <div class="goalImg">
            <lottie
              :options="kyoboGoalOpt"
              @animCreated="handleAnimation"
              v-observe-visibility="(isVisible, entry) => observePlay(isVisible, entry)"
            />
          </div>
        </div>

        <div class="kyoboCon concept">
          <div class="viewInner">
            <div class="smallTit">CONCEPT</div>
            <div
              class="conceptList"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <ul>
                <li>
                  <div class="conts">
                    <div class="tit"><span class="num">One Digital</span></div>
                    <p>모바일 중심으로 서비스 통합</p>
                  </div>
                </li>
                <li>
                  <div class="conts">
                    <div class="tit"><span class="num n2">Double Handed</span></div>
                    <p>가입 고객 서비스 &amp; 마케팅 플랫폼</p>
                  </div>
                </li>
                <li>
                  <div class="conts">
                    <div class="tit"><span class="num n3">Three Step</span></div>
                    <p>3 Step 안에 처리하는 극강의 편리함</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="kyoboCon focus type1">
          <div class="smallTit">FOCUS</div>
          <div
            class="txtWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="tit">
              <span class="num"
                >대규모 서비스에 <br class="mobile" />일관된 <b>사용자 경험</b> 적용</span
              >
            </div>
            <p>
              모바일과 PC를 합쳐 약 5,000 페이지 분량의
              <b>방대한 화면 UI 및 업무 프로세스 재구축</b>이 필요했으며, <br />
              150여 명의 인력이 참여하는 대형 프로젝트인 만큼
              <b>모든 파트에서 일관된 사용자 경험을 구현</b>하는 데 중점을 두었습니다.
            </p>
          </div>
          <div
            class="imgWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="line"></div>
            <div class="boxListWrap viewInner">
              <div class="border"></div>
              <ul class="boxList">
                <li>
                  <div class="step">STEP 01</div>
                  <p>서비스/콘텐츠<br />전략 정의</p>
                </li>
                <li>
                  <div class="step">STEP 02</div>
                  <p>정보<br />설계</p>
                </li>
                <li>
                  <div class="step">STEP 03</div>
                  <p>UI/UX<br />전략 수립</p>
                </li>
                <li>
                  <div class="step">STEP 04</div>
                  <p>공통<br />UI 정의</p>
                </li>
              </ul>
            </div>
            <ul class="littleDots">
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>
        <div class="kyoboCon focus type2">
          <div
            class="txtWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="tit">
              <span class="num n2">다양한 분야의 <br class="mobile" /><b>전문가와 협업</b></span>
            </div>
            <p>
              디지털 채널 전체를 리뉴얼하는 차세대 프로젝트의 성격에 맞게
              <b>각 분야의 전문 파트너사와 <br class="web" />협업</b>을 통해 서비스를 확장하고
              콘텐츠 품질 개선 및 검색 최적화를 이루었습니다.
            </p>
          </div>
          <div
            class="imgWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <ul class="keywordWrap">
              <li>
                <div class="circle">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 302 302"
                    style="enable-background:new 0 0 302 302;"
                    xml:space="preserve"
                  >
                    <g transform="translate(-460.256 -4096.038)">
                      <circle class="st0" cx="611.5" cy="4247.2" r="150" />
                      <path
                        class="st1"
                        d="M621,4097.1c5.7,0.3,11.4,0.9,17.1,1.8c14.8,2.4,29.2,7,42.7,13.7c0.5,0.2,0.7,0.8,0.5,1.3
                        c-0.2,0.5-0.8,0.7-1.3,0.5c-18.5-9.1-38.6-14.4-59.2-15.5c-39.7-2.1-78.5,11.7-108.1,38.2c-61.1,54.4-66.5,148.1-12,209.2
                        c0.4,0.4,0.7,0.8,1.1,1.2c0.4,0.4,0.3,1-0.1,1.4c-0.4,0.4-1,0.3-1.4-0.1c-6.9-7.6-13-15.9-18.2-24.7c-10.1-17-16.7-35.8-19.4-55.3
                        c-2.7-19.2-1.7-38.8,3-57.6c4.8-19.2,13.3-37.2,25.1-53c24.7-33.2,61.9-55,103-60.2C602.7,4097,611.9,4096.6,621,4097.1z"
                      />
                    </g>
                  </svg>
                </div>
                <p>콘텐츠<br />제작</p>
              </li>
              <li>
                <div class="circle">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 302 302"
                    style="enable-background:new 0 0 302 302;"
                    xml:space="preserve"
                  >
                    <g transform="translate(-1266 -4104)">
                      <circle class="st0" cx="1416.4" cy="4254.6" r="150" />
                      <path
                        class="st1"
                        d="M1420.8,4405.4c-5.7,0.2-11.4,0.1-17.2-0.4c-15-1.1-29.7-4.5-43.7-9.9
                        c-0.5-0.2-0.8-0.8-0.6-1.3c0.2-0.5,0.8-0.8,1.3-0.6l0,0c19.2,7.5,39.7,11,60.3,10.3c39.7-1.4,77.1-18.5,104.3-47.4
                        c56.1-59.5,53.3-153.2-6.2-209.3c-0.4-0.4-0.8-0.7-1.2-1.1c-0.4-0.4-0.4-1-0.1-1.4c0.4-0.4,1-0.4,1.4-0.1c7.5,7,14.3,14.7,20.3,23
                        c11.5,16,19.7,34.2,24.2,53.4c4.4,18.9,5.1,38.4,2,57.6c-3.1,19.5-10,38.2-20.4,54.9c-21.7,35.2-56.8,60.1-97.3,68.9
                        C1439.1,4403.9,1430,4405,1420.8,4405.4z"
                      />
                    </g>
                  </svg>
                </div>
                <p>접근성<br />컨설팅</p>
              </li>
              <li>
                <div class="circle">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 302 302"
                    style="enable-background:new 0 0 302 302;"
                    xml:space="preserve"
                  >
                    <g transform="translate(-442.737 -4043.527)">
                      <circle class="st0" cx="593.7" cy="4195.4" r="150" />
                      <path
                        class="st1"
                        d="M719.4,4111c3.2,4.7,6.1,9.7,8.8,14.7c7,13.3,11.9,27.5,14.7,42.3c0.1,0.5-0.3,1.1-0.8,1.2
                        c-0.5,0.1-1.1-0.3-1.2-0.8c-3.8-20.2-11.7-39.5-23.2-56.6c-22.2-32.9-56.5-55.7-95.5-63.3c-80.2-16.1-158.2,35.9-174.3,116.1
                        c-0.1,0.5-0.2,1.1-0.3,1.6c-0.1,0.5-0.6,0.9-1.2,0.8c-0.5-0.1-0.9-0.6-0.8-1.2c1.9-10.1,4.8-19.9,8.7-29.4
                        c7.5-18.2,18.6-34.8,32.5-48.8c13.7-13.7,29.9-24.7,47.8-32.2c18.2-7.7,37.7-11.7,57.4-11.8c41.4-0.3,81.1,16.4,110,46.1
                        C708.5,4096.3,714.2,4103.4,719.4,4111z"
                      />
                    </g>
                  </svg>
                </div>
                <p>SEO<br />컨설팅</p>
              </li>
              <li>
                <div class="circle">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 302 302"
                    style="enable-background:new 0 0 302 302;"
                    xml:space="preserve"
                  >
                    <g transform="translate(-1242.737 -4104)">
                      <circle class="st0" cx="1393.7" cy="4254.6" r="150" />
                      <path
                        class="st1"
                        d="M1245.8,4282.3c0.3-0.5,0.9-0.6,1.4-0.3c0.2,0.1,0.4,0.4,0.4,0.6
                      c15.2,80.4,92.6,133.3,173,118.1c0.5-0.1,1.1-0.2,1.6-0.3c39-7.6,73.3-30.4,95.5-63.3c11.5-17.1,19.4-36.3,23.2-56.6
                      c0.1-0.5,0.6-0.9,1.2-0.8c0.5,0.1,0.9,0.6,0.8,1.2c-5.7,29.6-19.9,56.8-40.9,78.3c-28.9,29.6-68.6,46.3-110,46
                      c-19.7-0.1-39.2-4.2-57.4-11.9c-17.9-7.6-34.1-18.5-47.8-32.2c-13.9-14-25-30.5-32.5-48.8c-3.9-9.5-6.8-19.3-8.7-29.4
                      C1245.6,4282.8,1245.6,4282.6,1245.8,4282.3z"
                      />
                    </g>
                  </svg>
                </div>
                <p>UX<br />라이팅</p>
              </li>
            </ul>
            <ul class="illustWrap">
              <li>
                <img src="@/assets/images/works_view/kyobo/illust_01_focus2.png" alt="" />
              </li>
              <li>
                <img src="@/assets/images/works_view/kyobo/illust_02_focus2.png" alt="" />
              </li>
            </ul>
          </div>
        </div>
        <div class="kyoboCon focus type3">
          <div class="viewInner">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit">
                <span class="num n3">업계 최초의 <br class="mobile" /><b>클라우드 기반 IT</b></span>
              </div>
              <p>
                <b>생명보험사 최초</b>로 클라우드 기반의 IT 인프라를 마련하고 이를 기반으로 채널
                서비스를 개발했습니다. <br class="web" /><b>시범 오픈 및 테스트를 수행</b>하며
                대규모 서비스의 클라우드 개발과 오픈을 안정적으로 수행했습니다.
              </p>
            </div>
            <div class="imgWrap">
              <img src="@/assets/images/works_view/kyobo/img_focus3.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="kyoboCon feature type1">
          <div class="smallTit">FEATURE</div>
          <div
            class="txtWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="tit">
              <span class="num">콘텐츠 소비와 보험 업무를 위한 <b>양면형 UI</b></span>
            </div>
          </div>
          <div class="imgWrap">
            <div
              class="mobileApp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <ul>
                <li>
                  <div class="shapeTit">모바일 APP</div>
                  <div class="phone">
                    <div class="screen">
                      <img src="@/assets/images/works_view/kyobo/img_app_01_feature1.png" alt="" />
                    </div>
                  </div>
                </li>
                <li>
                  <ul class="zoom">
                    <li>
                      <img
                        src="@/assets/images/works_view/kyobo/img_app_btm_01_feature1.png"
                        alt=""
                      />
                    </li>
                    <li>
                      <img
                        src="@/assets/images/works_view/kyobo/img_app_btm_02_feature1.png"
                        alt=""
                      />
                    </li>
                    <li>
                      <img
                        src="@/assets/images/works_view/kyobo/img_app_btm_03_feature1.png"
                        alt=""
                      />
                    </li>
                  </ul>
                  <div class="desc arrow">
                    <div class="txt">
                      <div class="tit">계약 정보 &amp; 혜택</div>
                      <p>
                        핵심 서비스인 보험 계약 정보와 혜택을 볼 수 있는<br />개인화 페이지는
                        Bottom-up 레이어로 분리해<br />가독성을 높였습니다.
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="desc">
                    <div class="tit">콘텐츠</div>
                    <p>로그인 없이 다양한 제휴 서비스를<br />이용할 수 있습니다</p>
                  </div>
                  <ul class="zoom">
                    <li>
                      <img
                        src="@/assets/images/works_view/kyobo/img_app_bnr_01_feature1.png"
                        alt=""
                      />
                    </li>
                    <li>
                      <img
                        src="@/assets/images/works_view/kyobo/img_app_bnr_02_feature1.png"
                        alt=""
                      />
                    </li>
                    <li>
                      <img
                        src="@/assets/images/works_view/kyobo/img_app_bnr_03_feature1.png"
                        alt=""
                      />
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div
              class="mobileWeb"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <ul>
                <li>
                  <div class="shapeTit">모바일 WEB</div>
                  <div class="phone">
                    <div class="screen">
                      <img src="@/assets/images/works_view/kyobo/img_web_01_feature1.png" alt="" />
                    </div>
                  </div>
                </li>
                <li>
                  <ul class="zoom">
                    <li>
                      <img
                        src="@/assets/images/works_view/kyobo/img_web_menu_feature1.png"
                        alt=""
                      />
                    </li>
                  </ul>
                  <div class="desc arrow">
                    <div class="txt">
                      <div class="tit">빠른메뉴</div>
                      <p>
                        보험, 퇴직연금, 대출, 펀드, 신탁 등의<br />금융 업무에 빠르게 접근할 수
                        있습니다.
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="phone">
                    <div class="screen">
                      <img src="@/assets/images/works_view/kyobo/img_web_02_feature1.png" alt="" />
                    </div>
                  </div>
                  <div class="fade"></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="kyoboCon feature type2">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit">
                <span class="num n2"
                  >편안하고 친절한 <br class="mobile" /><b>대화형 인터페이스</b></span
                >
              </div>
              <p>
                사용자 입장에서 귀찮지만, 꼭 필요한 본인 확인 및 <br class="mobile" />인증 절차를
                <b>거부감 없이 진행할 수 있도록 </b> <br class="web" />편안하고 위트 있는 멘트로
                <b>심리적 안정감을 줄 수 있는 CUI(Conversational User Interface)</b>를 사용했습니다.
              </p>
            </div>
            <div
              class="imgWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <ul class="phoneList">
                <li>
                  <div class="phone">
                    <div class="screen">
                      <img src="@/assets/images/works_view/kyobo/img_feature2_01.png" alt="" />
                    </div>
                  </div>
                </li>
                <li>
                  <div class="phone">
                    <div class="screen">
                      <img src="@/assets/images/works_view/kyobo/img_feature2_02.png" alt="" />
                    </div>
                  </div>
                </li>
                <li>
                  <div class="phone">
                    <div class="screen">
                      <img src="@/assets/images/works_view/kyobo/img_feature2_03.png" alt="" />
                    </div>
                  </div>
                </li>
              </ul>
              <ul class="speechList">
                <li>
                  <p>잠깐, 교보생명 앱<br /><b>설치하셨나요?</b></p>
                </li>
                <li>
                  <p><b>환영합니다.</b><br />이제 교보생명 가족이에요</p>
                </li>
                <li>
                  <p>무엇에<br /><b>관심</b>이 많으세요?</p>
                  <span class="web">관심 키워드에 딱 맞는 꿀팁을 준비했어요 :&#41;</span>
                  <span class="mobile">꿀팁을 준비했어요 :&#41;</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="kyoboCon feature type3">
          <div
            class="txtWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="tit">
              <span class="num n3"
                ><b>금융</b>과 <b>비금융</b>을 <br class="mobile" />어우르는 콘텐츠</span
              >
            </div>
            <p>
              검색 엔진에 최적화된 <b>테크니컬 SEO</b>를 적용해 <br class="mobile" />가망 고객의
              유입을 유도했으며, <br class="web" />향후 다양한 제휴 서비스로
              <b>확장할 수 있는 UI 원칙을 수립</b>하고 적용했습니다.
            </p>
          </div>
          <div class="imgWrap">
            <div class="phone">
              <div class="screen">
                <img src="@/assets/images/works_view/kyobo/img_feature3.png" alt="" />
              </div>
            </div>
            <div class="zoomSlider swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kyobo/img_slider01.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kyobo/img_slider02.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kyobo/img_slider03.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kyobo/img_slider04.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kyobo/img_slider05.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <img src="@/assets/images/works_view/kyobo/img_slider06.png" alt="" />
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-samsungF' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">삼성화재 모바일 웹 완결형 프로세스 구축</strong>
          <strong class="mobile">삼성화재<br />모바일 웹 완결형 프로세스 구축</strong>
        </div>

        <div class="engBg ssFireEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
import kyoboGoalImg from "@/assets/json/motion/kyoboGoalImg.json";
import { TweenLite } from "gsap/all";

Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
      title: {
        inner: "교보생명"
      }
    }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      meta: {
        siteName: "교보생명 홈페이지 및 모바일 웹&앱 | 플립커뮤니케이션즈",
        title: "교보생명 홈페이지 및 모바일 웹&앱",
        desc:
          "교보생명은 모바일을 중심으로 PC, 모바일 웹, 앱의 서비스를 통합하여 일관된 고객 경험을 제공하고자 대규모 디지털 채널 통합 리뉴얼 프로젝트를 수행했습니다. 생명보험사 최초 클라우드 기반 IT 인프라를 구축하고 양면형 UI로 콘텐츠 소비와 보험 업무를 동시에 지원합니다.",
        keywords:
          "교보생명, 모바일 통합, PC, Mobile web, App, 디지털 채널, 서비스 통합, 고객 경험, 확장된 서비스, 마이데이터 서비스, 제휴 서비스, 플랫폼 서비스, 사용자 경험, 검색 최적화, UI 원칙",
        url: "https://www.pulip.com/works/kyobo",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0,
      kyoboGoalOpt: { animationData: kyoboGoalImg, loop: false, autoplay: true }
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    // vuejs Bicint
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/kyobo").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    // visibilityChanged(isVisible, entry) {
    //   // this.isVisible = isVisible
    //   console.log(entry);
    // },
    handleAnimation(anim) {
      this.anim = anim;
    },
    observePlay(isVisible, entry) {
      if (isVisible) {
        this.anim.play();
      } else {
        this.anim.stop();
      }
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.zoomSlider.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.zoomSlider = new window.Swiper(".zoomSlider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 1.8,
      centeredSlides: true,
      loop: true,
      spaceBetween: 10,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      initialSlide: 1,
      breakpoints: {
        891: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
      // onSlideChangeEnd:function(e){
      //   zoomSlider.update(true);
      // },
    });
  }
};
</script>
